import ColorDark from '../Color/Dark/index';
import ColorLight from '../Color/Light/index';

export default {
  dark: {
    color: ColorDark,
  },
  light: {
    color: ColorLight,
  },
};
